if (!customElements.get('bs-indice')) customElements.define('bs-indice', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.article = this.closest('.bs-articulo');
    if (!this.article) return;

    this.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest?.('a[href]');
      if (!link || !this.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      const target = this.targetForHash(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      if (this.targetForHash(window.location.hash) !== target) {
        const url = new URL(window.location.href);
        url.hash = encodeURIComponent(target.id);
        window.history.pushState(window.history.state, '', url);
      }
      this.moveTo(target);
    }, { signal, capture: true });

    window.addEventListener('hashchange', () => {
      const target = this.targetForHash(window.location.hash);
      if (target) this.moveTo(target);
    }, { signal });
  }

  targetForHash(hash) {
    if (!hash?.startsWith('#') || hash.length === 1) return null;
    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch {
      return null;
    }
    return [...this.article.querySelectorAll('.bs-articulo-cuerpo h2[id]')]
      .find(heading => heading.id === id && heading.closest('.bs-articulo') === this.article);
  }

  moveTo(target) {
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start'
    });
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  }

  disconnectedCallback() {
    this.abort?.abort();
  }
});
